import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Candidate|Security|Dashboard|Watch Section|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Core,
	portal: 'SP',
};

type LocNameStart = 'SPCandidateWatchSection';
export type SPCandidateWatchSectionLocNames =
	| `${LocNameStart}TitleSection`
	| `${LocNameStart}LabelWatched`
	| `${LocNameStart}LabelWatchedUntil`
	| `${LocNameStart}NotificationWatchSuccess`
	| `${LocNameStart}NotificationWatchFailure`
	| `${LocNameStart}ButtonEdit`
	| `${LocNameStart}ButtonCancel`
	| `${LocNameStart}ButtonUpdate`;

export const spCandidateWatchSectionLocs: LocDefs<SPCandidateWatchSectionLocNames> = {
	SPCandidateWatchSectionTitleSection: {
		defaultValue: 'Watch',
		description: 'Title for: Watch.',
		displayPath: `${pathStart}Watch`,
		displayType: 'Title',
		legacyName: 'Exam.Security/CandidateSecurity.Dashboard.Title.WatchSection',
		...sharedProperties,
	},
	SPCandidateWatchSectionLabelWatched: {
		defaultValue: 'Watched',
		description: 'Label for: Watched.',
		displayPath: `${pathStart}Watched`,
		displayType: 'Label',
		legacyName: 'Exam.Security/CandidateSecurity.Dashboard.FieldLabel.Watched',
		...sharedProperties,
	},
	SPCandidateWatchSectionLabelWatchedUntil: {
		defaultValue: 'Watched Until',
		description: 'Label for: Watched Until.',
		displayPath: `${pathStart}Watched Until`,
		displayType: 'Label',
		legacyName: 'Exam.Security/CandidateSecurity.Dashboard.FieldLabel.WatchedUntil',
		...sharedProperties,
	},
	SPCandidateWatchSectionNotificationWatchSuccess: {
		defaultValue: 'Candidate status successfully updated',
		description: 'Notification for: Candidate status successfully updated.',
		displayPath: `${pathStart}Candidate status successfully updated`,
		displayType: 'Notification',
		legacyName: 'Exam.Security/CandidateSecurity.Dashboard.NotificationMessage.UpdateSuccess',
		...sharedProperties,
	},
	SPCandidateWatchSectionNotificationWatchFailure: {
		defaultValue: 'Something went wrong, please contact support',
		description: 'Notification for: Something went wrong, please contact support.',
		displayPath: `${pathStart}Something went wrong, please contact support`,
		displayType: 'Notification',
		legacyName: 'Exam.Security/CandidateSecurity.Dashboard.NotificationMessage.UpdateFailure',
		...sharedProperties,
	},
	SPCandidateWatchSectionButtonEdit: {
		defaultValue: 'Edit',
		description: 'Button for editing watched status',
		displayPath: `${pathStart}Edit Watch`,
		displayType: 'Button',
		...sharedProperties,
	},
	SPCandidateWatchSectionButtonCancel: {
		defaultValue: 'Cancel',
		description: 'Button to cancel editing watched status',
		displayPath: `${pathStart}Cancel Edit`,
		displayType: 'Button',
		...sharedProperties,
	},
	SPCandidateWatchSectionButtonUpdate: {
		defaultValue: 'Remove or Update Watch',
		description: 'Button to update watched status',
		displayPath: `${pathStart}Update`,
		displayType: 'Button',
		...sharedProperties,
	},
};

export type SPCandidateWatchSectionLocType = LocMap<SPCandidateWatchSectionLocNames>;
